export class VersionedData<T> {
  public data: T;
}
